import React, { useRef } from 'react';
import { DropdownTrigger } from 'react-simple-dropdown';
import Tooltip from '@omilia/tooltip';

import useDropdown from 'utils/hooks/useDropdown';
import useToggle from 'utils/hooks/useToggle';

import ShortcutsModal from './components/ShortcutsModal';

import {
  StyledDropdownContent,
  StyledHeaderMenuItemLabel,
  StyledHeaderMenuItemIcon,
  StyledMenuItem,
  StyledDropdownContentBody,
  StyledDropdownContentHeader,
  StyledDropdownContentHeaderTitle,
} from '../HeaderDropdownMenu/styled';

import { StyledDropdown, StyledHeaderIcon } from './styled';

const ShortcutsMenu = () => {
  const [
    shortcutsModalIsOpen,
    { toggle: toggleShortcutsModal, reset: resetShortcutsModal },
  ] = useToggle();

  const dropdownElem = useRef(null);
  const { hide: hideDropdown } = useDropdown(dropdownElem);

  const handleItemClick = () => {
    hideDropdown();
    toggleShortcutsModal();
  };

  return (
    <React.Fragment>
      <StyledDropdown ref={dropdownElem}>
        <DropdownTrigger>
          <Tooltip content="Need some Help?" placement="left">
            <StyledHeaderIcon
              className="icon-help"
              data-test="shortcuts-menu-trigger"
            />
          </Tooltip>
        </DropdownTrigger>
        <StyledDropdownContent>
          <StyledDropdownContentHeader>
            <StyledDropdownContentHeaderTitle>
              Need some Help?
            </StyledDropdownContentHeaderTitle>
          </StyledDropdownContentHeader>
          <StyledDropdownContentBody>
            <StyledMenuItem
              as="a"
              data-test="shortcuts"
              onClick={handleItemClick}
            >
              <StyledHeaderMenuItemIcon className="icon-keyboard" />
              <StyledHeaderMenuItemLabel>
                Keyboard Shortcuts
              </StyledHeaderMenuItemLabel>
            </StyledMenuItem>
          </StyledDropdownContentBody>
        </StyledDropdownContent>
      </StyledDropdown>

      <ShortcutsModal
        isOpen={shortcutsModalIsOpen}
        onCloseRequest={resetShortcutsModal}
      />
    </React.Fragment>
  );
};

export default ShortcutsMenu;
